module.exports = {
    hide: () => { },
    show: () => { },
};
